import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async request => {
  try {
    const response = await tuApptoAPI.post('/assemblies/findall', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/assemblies/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async id => {
  try {
    const response = await tuApptoAPI.delete(`/assemblies/delete/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const findAllResolution = async request => {
  try {
    const response = await tuApptoAPI.post('/assemblies/resolutions/findall', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const createResolution = async request => {
  try {
    const response = await tuApptoAPI.post('/assemblies/resolutions/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const updateResolution = async request => {
  try {
    const response = await tuApptoAPI.put('/assemblies/resolutions/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const removeAssembly = async id => {
  try {
    const response = await tuApptoAPI.delete(`/assemblies/resolutions/delete/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
